import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAdaptiveTextColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompFieldRatingWrapperCore } from '../core/forms/rating/wrapper'
import { CompFieldRating } from './CompFieldRating'

/**
 * CompFieldRatingWrapper
 */
function CompFieldRatingWrapper() {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useAdaptiveTextColor()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompFieldRatingWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompFieldRating {...props} />}
    </CompFieldRatingWrapperCore>
  )
}


export default CompFieldRatingWrapper